module.exports = "<div v-if=\"content\">\n\t<transition :name=\"transition\">\n\t\t<qd-apps-overview\n\t\tv-if=\"resetOnce\"/>\n\t</transition>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/post-types/page-default/page-default.vhtml
// module id = 250
// module chunks = 0